// extracted by mini-css-extract-plugin
export var checkLabel = "styles-module--checkLabel--b81ff";
export var checkbox = "styles-module--checkbox--ff8a6";
export var error = "styles-module--error--77345";
export var input = "styles-module--input--13a55";
export var label = "styles-module--label--6ef8f";
export var wrapper = "styles-module--wrapper--7a70b";